import { Search } from "@carbon/react";
import PropTypes from 'prop-types';
import React from 'react';

function BrandsIndexSearch({ value, onChange }) {
  function handleOnChange(event) {
    onChange(event.target.value);
  }

  return (
    <div className="component-index-search">
      <Search
        id="component-index-search"
        size='lg'
        labelText="Поиск брендов по названию."
        placeholder="Поиск брендов"
        value={value}
        onChange={handleOnChange}
      />
    </div>
  );
}

BrandsIndexSearch.propTypes = {
  /**
   * Receive an update for the latest value and use it to update the passed in
   * `value`
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Control the value of the search using the `value` prop
   */
  value: PropTypes.string.isRequired,
};

export default BrandsIndexSearch;
